import { render, staticRenderFns } from "./waiter.vue?vue&type=template&id=a8e18a3c&"
import script from "./waiter.vue?vue&type=script&lang=js&"
export * from "./waiter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports